import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Grid } from 'semantic-ui-react';

const QuickServeItems = props => {
  const { quickServeItems, handleQuickServeItemChange } = props;
  return (
    <Grid.Column>
      <div className="text-center text-primary">
        <label>Select food item</label>
      </div>
      <Dropdown
        className="servingOpton-dropdown"
        placeholder="Please select food item"
        selection
        options={quickServeItems}
        size="large"
        fluid
        onChange={handleQuickServeItemChange}
      />
    </Grid.Column>
  );
};

QuickServeItems.propTypes = {
  quickServeItems: PropTypes.array,
  handleQuickServeItemChange: PropTypes.func,
};

QuickServeItems.defaultProps = {
  quickServeItems: [{ key: 1, value: 'None', text: 'None' }],
};

export default QuickServeItems;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/servingOptionCategory/component/Quickserve.js